/* Live search placeholder: types "Search for <product>" into any search input
   that carries data-hints (newline separated), clears it and types the next.
   Pauses while the field is focused or has a value, and simply swaps the text
   when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function start(input) {
    var hints = (input.dataset.hints || '').split(/\r?\n/).map(function (h) { return h.trim(); }).filter(Boolean);
    if (hints.length < 1) return;
    var prefix = input.dataset.hintPrefix || '';
    var base = input.getAttribute('placeholder') || '';
    var i = 0, pos = 0, deleting = false, timer = null, paused = false;
    function idle() { return document.activeElement === input || input.value !== ''; }
    function set(text) { input.setAttribute('placeholder', text); }
    function phrase() { return prefix + hints[i]; }
    function tick() {
      if (idle()) { paused = true; set(base); timer = setTimeout(tick, 600); return; }
      if (paused) { paused = false; pos = 0; deleting = false; }
      var full = phrase();
      if (reduce) { set(full); i = (i + 1) % hints.length; timer = setTimeout(tick, 2600); return; }
      if (!deleting) {
        pos++; set(full.slice(0, pos));
        if (pos >= full.length) { deleting = true; timer = setTimeout(tick, 1800); return; }
        /* the fixed opening words go quickly, the product name at a typing pace */
        timer = setTimeout(tick, pos <= prefix.length ? 32 : 55 + Math.random() * 45);
      } else {
        pos--; set(full.slice(0, pos));
        if (pos <= 0) { deleting = false; i = (i + 1) % hints.length; timer = setTimeout(tick, 320); return; }
        timer = setTimeout(tick, 22);
      }
    }
    input.addEventListener('focus', function () { set(base); });
    input.addEventListener('blur', function () { if (input.value === '') { pos = 0; deleting = false; } });
    timer = setTimeout(tick, 450);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(timer); } else { timer = setTimeout(tick, 400); }
    });
  }
  function init() { document.querySelectorAll('input[type="search"][data-hints]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
